import React from 'react';
import { CampaignAddEditContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { ROUTE_PATH } from 'utils/constants/routePath';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import { portalService } from 'apiServices';
import { toast } from 'react-toastify';
import { Forms, Displays, Modals } from 'components';

class CampaignAddEditContainer extends React.Component {
  state = {
    isLoading: true,
    labelSuccess:
      this.props.router.params.id === 'create' ? 'สร้างสำเร็จ' : 'แก้ไขสำเร็จ',
    labelError:
      this.props.router.params.id === 'create'
        ? 'สร้างไม่สำเร็จ'
        : 'แก้ไขไม่สำเร็จ',
  };

  componentDidMount() {
    scrollToTopPageFN();
    if (this.props.router.params.id !== 'create') {
      this.fetchData();
    } else {
      setTimeout(() => {
        this.setState({
          isLoading: false,
        });
      }, 400);
    }
  }

  fetchData = async () => {
    let res = await portalService.GET_CAMPAIGN_BY_ID(
      this.props.router.params.id
    );

    if (res && res.status === 200) {
      this.setState({
        initialValues: res.data,
        isLoading: false,
      });
    }
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: null,
    });
  };

  handleDelete = () => {
    this.setState({
      renderModal: (
        <Displays.CofirmBox
          label="คุณต้องการลบใช่หรือไม่ ?"
          labelBtn1="Confirm"
          labelBtn2="Cancel"
          onAction1={this.deleteAction}
          onAction2={this.handleCloseModal}
        />
      ),
    });
  };

  deleteAction = async () => {
    this.setState({
      isBgLoading: true,
    });
    let res = await portalService.DELETE_CAMPAIGN(this.props.router.params.id);
    if (res && res.status === 200) {
      toast.success('ลบสำเร็จ');
      this.handleNextStep();
    } else {
      toast.error('ลบไม่สำรเร็จ');
    }
  };

  handleDuplicate = () => {};

  handleSubmit = async (values) => {
    const { labelSuccess, labelError } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let params = {
      ...values,
    };
    if (values.isDuplicate) {
      delete params._id;
      delete params.front_img;
      delete params.campaign_img;
      delete params.created_at;
      delete params.updated_at;
      params.code = `${values.code}-${new Date().getTime()}`;
    }
    let res =
      this.props.router.params.id === 'create' || values.isDuplicate
        ? await portalService.POST_CAMPAIGN(params)
        : await portalService.PUT_CAMPAIGN(this.props.router.params.id, params);
    if (res && res.status === 200) {
      let filesTemp = [];
      if (values.campaign_img_file) {
        filesTemp = [
          ...filesTemp,
          ...values.campaign_img_file.filter((e) => e.isNewUpload),
        ];
      }
      if (values.front_img_file) {
        filesTemp = [
          ...filesTemp,
          ...values.front_img_file.filter((e) => e.isNewUpload),
        ];
      }
      if (filesTemp.length === 0) {
        toast.success(labelSuccess);
        this.handleNextStep();
      } else {
        this.handleUploadContentMedia(res.data._id, filesTemp);
      }
    } else {
      this.setState({
        isBgLoading: false,
      });
      toast.error(labelError);
    }
  };

  handleUploadContentMedia = (campaignID, files) => {
    Promise.all(
      files.map((e) => {
        return new Promise(async (resolve) => {
          if (e.isNewUpload) {
            const bodyFormData = new FormData();
            bodyFormData.set('campaign_id', campaignID);
            bodyFormData.set('type', e.fieldName);
            bodyFormData.append('image', e);
            let res = await portalService.POST_UPLOAD_CAMPAIGN(bodyFormData);
            if (res && res.status === 200) {
              resolve();
            }
          }
        });
      })
    ).then(() => {
      this.setState({
        isBgLoading: false,
      });
      toast.success('อัพเดจสำเร็จ');
      this.handleNextStep();
    });
  };

  handleNextStep = () => {
    this.props.router.navigate(`${ROUTE_PATH.CAMPAIGN_DATA}`);
  };

  render() {
    const { isLoading, initialValues, isBgLoading, renderModal } = this.state;
    return (
      <CampaignAddEditContainerStyled>
        {isLoading ? (
          <div className="loading_show">
            <Displays.Loading />
          </div>
        ) : (
          <>
            <Displays.BGLoading visible={isBgLoading} />
            <Forms.CampaignForm
              initialValues={initialValues && initialValues}
              onCancel={this.handleNextStep}
              onSubmit={this.handleSubmit}
              onDelete={this.handleDelete}
              onDuplicate={this.handleDuplicate}
            />
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </CampaignAddEditContainerStyled>
    );
  }
}

export default withRouter(CampaignAddEditContainer);
